"use client";

import { Toaster as Sonner, type ToasterProps } from "sonner";
import {
  CircleCheckIcon,
  InfoIcon,
  TriangleAlertIcon,
  OctagonXIcon,
  Loader2Icon,
} from "lucide-react";

import { getAppTheme } from "@/shared/environment";

const Toaster = ({ ...props }: ToasterProps) => (
  <Sonner
    theme={getAppTheme()}
    className="toaster group"
    icons={{
      success: <CircleCheckIcon className="size-4" />,
      info: <InfoIcon className="size-4" />,
      warning: <TriangleAlertIcon className="size-4" />,
      error: <OctagonXIcon className="size-4" />,
      loading: <Loader2Icon className="size-4 animate-spin" />,
    }}
    style={
      {
        "--normal-bg": "var(--popover)",
        "--normal-text": "var(--popover-foreground)",
        "--normal-border": "var(--border)",
        "--border-radius": "12px",
        "--success-bg": "var(--popover)",
        "--success-text": "var(--popover-foreground)",
        "--success-border": "var(--border)",
        "--error-bg": "var(--popover)",
        "--error-text": "var(--popover-foreground)",
        "--error-border": "var(--border)",
      } as React.CSSProperties
    }
    toastOptions={{ classNames: { toast: "cn-toast" } }}
    {...props}
  />
);

export { Toaster };
